require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-spencerwi-generator-ocaml-bucklescript-webpack.json") })
        }
      }, "path---package-unpublished-spencerwi-generator-ocaml-bucklescript-webpack");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-spencerwi-generator-ocaml-bucklescript-webpack!./.cache/json/package-unpublished-spencerwi-generator-ocaml-bucklescript-webpack.json
// module id = 964
// module chunks = 231608221292675